<template>
  <section class="collapsible-section">
    <div class="section-title">
      <header class="section-header">
        <h2 class="section-heading">
          {{  heading }}
        </h2>
        <div @click="handleExpandClick()" class="icon-selector">
          <div class="icon-container">
            <i v-if="!showExpanded" class="uil uil-plus-circle" style="font-size: 24px;"></i>
            <i v-if="showExpanded" class="uil uil-times" style="font-size: 24px;"></i>
          </div>
        </div>
      </header>
      <hr class="section-divider">
    </div>
    <div class="section-content">
      <p class="content-description" v-html="content"></p>
      <transition name="slide-fade">
        <p v-show="showExpanded" class="expanded-content-description">
          <template v-if="extraContent === 'cost_analysis_table'">
            <sp-2-lnob-cost-analysis :data="costAnalysisData"></sp-2-lnob-cost-analysis>
          </template>
          <template v-else-if="extraContent === 'decision_tree'">
            <sp-2-lnob-decision-tree :data_source="dataSource" :data="treeData"></sp-2-lnob-decision-tree>
          </template>
          <template v-else-if="extraContent === 'distribution_access'">
            <sp-2-lnob-distribution-access :data="dotPlotData"></sp-2-lnob-distribution-access>
          </template>
          <template v-else-if="extraContent === 'group_size_changes'">
            <sp-2-lnob-group-size-changes :data="sankeyData"></sp-2-lnob-group-size-changes>
          </template>
          <template v-else-if="extraContent === 'inequality_analysis'">
            <sp-2-lnob-inequality-analysis :data="inequalityAnalysisData"></sp-2-lnob-inequality-analysis>
          </template>
          <template v-else-if="extraContent === 'inequality_metrics'">
            <sp-2-lnob-inequality-metrics :data="inequalityMetricsData"></sp-2-lnob-inequality-metrics>
          </template>
          <template v-else>
            {{ extraContent }}
          </template>
        </p>
      </transition>
    </div>
  </section>
</template>

<script>
import Sp2LnobCostAnalysis from './Sp2LnobCostAnalysis.vue';
import Sp2LnobDecisionTree from './Sp2LnobDecisionTree.vue';
import Sp2LnobDistributionAccess from './Sp2LnobDistributionAccess.vue';
import Sp2LnobGroupSizeChanges from './Sp2LnobGroupSizeChanges.vue';
import Sp2LnobInequalityAnalysis from './Sp2LnobInequalityAnalysis.vue';
import Sp2LnobInequalityMetrics from './Sp2LnobInequalityMetrics.vue';
export default {
  name: 'CollapsiblePanel',
  components: {
    Sp2LnobCostAnalysis,
    Sp2LnobDecisionTree,
    Sp2LnobDistributionAccess,
    Sp2LnobGroupSizeChanges,
    Sp2LnobInequalityAnalysis,
    Sp2LnobInequalityMetrics
  },
  props: {
    heading: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    extraContent: {
      type: String,
      default: ''
    },
    initShowExpanded: {
      type: Boolean,
      default: true
    },
    data: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      showExpanded: this.initShowExpanded,
      treeData: null,
      costAnalysisData: null,
      dotPlotData: null,
      sankeyData: null,
      inequalityAnalysisData: null,
      inequalityMetricsData: null,
      dataSource: null
    };
  },
  watch: {
    initShowExpanded: {
      handler: function () {
        this.showExpanded = true;
      }
    },
    data: {
      handler: function (data) {
        this.costAnalysisData = data.cost_analysis;
        this.treeData = data.tree;
        this.dotPlotData = data.dot_plot;
        this.sankeyData = data.flow_plot;
        this.inequalityMetricsData = data.ineq_table;
        this.inequalityAnalysisData = data.gini_plot;
        this.dataSource = data.metadata.data_source;
      }
    }
  },
  methods: {
    handleExpandClick () {
      this.showExpanded = !this.showExpanded;
    }
  }
};
</script>

<style scoped>
.collapsible-section {
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid #b8bcc9;
  padding: 10px 20px 20px;
  overflow: hidden;
  background-color: #fff;
  width: 95%;
  margin: 10px auto;
}

.section-title {
  width: 100%;
}

@media (max-width: 991px) {
  .section-title {
    max-width: 100%;
  }
}

.section-header {
  display: flex;
  width: 100%;
  padding: 4px 8px;
  align-items: center;
  justify-content: start;
  flex-wrap: wrap;
}

@media (max-width: 991px) {
  .section-header {
    max-width: 100%;
  }
}

.section-heading {
  color: #212529;
  font-family: Roboto, -apple-system, Roboto, Helvetica, sans-serif;
  font-size: 28px;
  font-weight: 500;
  align-self: stretch;
  margin-top: auto;
  margin-bottom: auto;
  flex: 1;
  flex-shrink: 1;
  flex-basis: 0%;
}

@media (max-width: 991px) {
  .section-heading {
    max-width: 100%;
  }
}

.icon-selector {
  align-self: stretch;
  display: flex;
  margin-top: auto;
  margin-bottom: auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 24px;
  cursor: pointer;
  padding: 0px 20px;
}

.icon-container {
  display: flex;
  width: 24px;
  flex-direction: column;
  overflow: hidden;
  align-items: center;
  justify-content: center;
}

.icon-image {
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  width: 100%;
}

.section-divider {
  border: none;
  border-top: 2px solid rgba(68, 153, 69, 1);
  background-color: #449945;
  min-height: 1px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 100%;
}

@media (max-width: 991px) {
  .section-divider {
    max-width: 100%;
  }
}

.section-content {
  margin-top: 15px;
  width: 100%;
  font-family: Roboto, -apple-system, Roboto, Helvetica, sans-serif;
  font-size: 16px;
  color: #2e2e2e;
  font-weight: 400;
}

@media (max-width: 991px) {
  .section-content {
    max-width: 100%;
  }
}

.content-description {
  color: #2e2e2e;
  width: 100%;
  padding: 2px 8px;
  margin-bottom: 0px;
}

@media (max-width: 991px) {
  .content-description {
    max-width: 100%;
  }
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}
</style>
